<template>
  <div>
    <Header />
    <div class="nav-section">
      <span class="navTitle">
        <span class="navTitle"> {{ name }} > Paramètres</span>
      </span>
      <br />
      <div class="menu">
        <q-btn color="pink-10" class="back-btn" @click="navigate">Retour</q-btn>
        <q-btn color="orange" class="back-btn" @click="navigateToIntermediate"
          >Gérer les pages intermediaires</q-btn
        >

        <q-btn v-if="imgLoaded" color="secondary" @click="send"
          >Enregistrer le point</q-btn
        >
      </div>
    </div>
    <hr class="hr-bottom" />
    <div class="select-section">
      <FileSelect
        :options="options"
        option-label="title"
        emit-value
        map-options
        outlined
        v-model="model"
        label="Choisir la ressource principale"
        @update:model-value="handleImageChange"
        dense
      />
      
    </div>
    <br />
    <div class="main-section">
      <div id="container" class="container-section"></div>
      <div class="add-circle-section" v-if="imgLoaded">
        <q-input outlined label="Nom du point" v-model="pointName" dense />
        <q-btn v-if="imgLoaded" @click="addCircle" color="primary"
          >Ajouter un point</q-btn
        >
        <div>
          <div>
            <span>Liste des points et des ressources</span>
            <div v-for="(value, key, index) in resourcesFromPoints" :key="key">
              Point {{ index + 1 }}
              <ul>
                <li v-for="item in value" :key="item.resource_id">
                  {{ item.title }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="form-section" v-if="form">
        <q-form class="form">
          <q-input v-model="formName" outlined label="Nom du fichier" disable />
          <q-input outlined v-model="title" label="Nom" required />
          <q-input
            outlined
            type="textarea"
            label="Description"
            v-model="description"
          />
          <input
            outlined
            type="file"
            label="Fichier"
            ref="file"
            @change="selectFile"
          />
          <q-btn color="secondary" class="send-btn" @click="save"
            >Enregistrer la ressource</q-btn
          >
          <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
            Ressource enregistrée
          </q-banner>
        </q-form>
      </div>
    </div>
    <q-inner-loading :showing="visible">
        <q-spinner-gears size="50px" color="primary" />
      </q-inner-loading>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import Konva from "konva";
import { useRouter } from "vue-router";
import FileSelect from "../components/FileSelect.vue";

export default {
  components: { Header, FileSelect },

  setup() {
    const store = useStore();
    const router = useRouter();
    const name = computed(() => store.state.exhibitName);
    let homePageText = ref();
    let model = ref();
    let options = ref([]);
    let imgUrl = ref();
    let circles = ref([]);
    var stage;
    var layer;
    var form = ref(false);
    let formName = ref();
    let title = ref();
    let imgLoaded = ref(false);
    let visible = ref(false);
    let files = ref();
    let description = ref();
    let success = ref();
    let mainResourceId = ref();
    let resourcesFromPoints = ref();
    let mainResource = ref();
    let pointName = ref();
    const start = async () => {
      await getResources();
      await getMainResource();
      if (mainResourceId.value) {
        model.value = mainResource.value;
        handleImageChange();
      }
      await getResourcesFromPoints();
      await getPoints();
    };
    const getResources = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resources`;
        let body = {
          exhibitId: store.state.exhibitId,
        };
        let response = await axios.post(url, body);
        let results = response.data;
        options.value = results;
      } catch (error) {
        console.log(error);
      }
    };
    const getFile = async (name) => {
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
      let response = await axios.get(url);
      imgUrl.value = response.data;
    };

    const getMainResource = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/mainresource/${store.state.exhibitId}`;
        let response = await axios.get(url);
        if (response.data[0]) {
          mainResourceId.value = response.data[0].main_resource_id;
          mainResource.value = response.data[0];
        }
      } catch (error) {
        console.log(error);
      }
    };

    function blobToData(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }

    const getPoints = async ()=>{
      try {
        let url = `${process.env.VUE_APP_BASEURL}/points/${mainResourceId.value}`;
        let response = await axios.get(url);
        console.log("points")
        console.log(response.data);

      } catch (error) {
        console.log(error)
      }
    }

    const save = async () => {
      try {
        visible.value = true;
        for (var file of files.value) {
          let formData = new FormData();
          formData.append("file", file);
          formData.append("name", formName.value);
          formData.append("description", description.value);
          formData.append("title", title.value);
          formData.append("exhibitId", store.state.exhibitId);
          formData.append("index", options.value.length);
          let url = `${process.env.VUE_APP_BASEURL}/file`;
          let response = await axios.post(url, formData);
          let resourceIdAdded = response.data.resourceId;
          circles.value[circles.value.length - 1].resources.push({
            id: resourceIdAdded,
          });
          if (response.status == 200) {
            visible.value = false
            success.value = true;
            getResourcesFromPoints();
            setTimeout(() => {
              success.value = false;
            }, 1500);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    const selectFile = (event) => {
      files.value = event.target.files;
      if (event.target.files.length != 0)
        formName.value = event.target.files[0].name;
    };

    const handleCanva = () => {
      const maxWidth = window.innerWidth * 0.4;
      const imageObj = new Image();
      imageObj.src = imgUrl.value;
      imageObj.onload = function () {
        imgLoaded.value = true;
        visible.value = false;
        // Créer un stage Konva
        stage = new Konva.Stage({
          container: 'container',
          width: maxWidth,
          height: imageObj.height * (maxWidth / imageObj.width),
        });

        layer = new Konva.Layer();
        stage.add(layer);

        const image = new Konva.Image({
          x: 0,
          y: 0,
          image: imageObj,
          width: maxWidth,
          height: imageObj.height * (maxWidth / imageObj.width),
          scaleX: 1,
          scaleY: 1,
        });


        layer.add(image);
        layer.draw();
      };
    };

    const navigate = () => {
      router.go(-1);
    };

    const navigateToIntermediate = () => {
      router.push("/intermediate");
    };
    const getResourcesFromPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/pointsFromMainResource/${mainResourceId.value}`;
        let response = await axios.get(url);
        var outputJSON = {};

        response.data.forEach(function (item) {
          if (
            !Object.prototype.hasOwnProperty.call(outputJSON, item.point_id)
          ) {
            outputJSON[item.point_id] = [];
          }

          outputJSON[item.point_id].push(item);
        });
        resourcesFromPoints.value = outputJSON;
      } catch (error) {
        console.log(error);
      }
    };

    const addCircle = () => {
      form.value = false;
      form.value = true;
      var circle = new Konva.Circle({
        x: 100,
        y: 100,
        radius: 10,
        fill: "black",
        stroke: "white",
        strokeWidth: 2,
      });
      layer.add(circle);
      layer.draw();

      // Make the circle draggable
      circle.draggable(true);

      // Add a click event to the circle
      circle.on("dragend", function (e) {
        console.log(e);
        console.log(e.target.absolutePosition());
      });
      circles.value.push({
        circle: circle,
        resources: [],
        name: pointName.value,
      });
    };

    const handleImageChange = async () => {
      visible.value = true;
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${model.value.name}`;
      let response = await axios.get(url, { responseType: "blob" });
      const base64data = await blobToData(response.data);
      imgUrl.value = base64data;
      handleCanva();
    };


    const send = async () => {
      visible.value = true
      var postObjs = [];
      circles.value.map((element) => {
        var x = element.circle._lastPos.x;
        var y = element.circle._lastPos.y;
        var obj = {};
        obj.x = x;
        obj.y = y;
        obj.resourceId = model.value.id;
        obj.exhibitId = store.state.exhibitId;
        obj.resources = element.resources;
        obj.pointName = element.name;
        postObjs.push(obj);
      });
      try {
        let url = `${process.env.VUE_APP_BASEURL}/point`;
      let response = await axios.post(url, {
        data: postObjs,
      });
      if(response.status == 200){
        visible.value = false
        success.value = true
        setTimeout(() => {
            success.value = false;
          }, 1500);
      }
      } catch (error) {
        console.log(error)
      }
      
    };
    onMounted(start);
    return {
      name,
      homePageText,
      model,
      options,
      imgUrl,
      circles,
      form,
      formName,
      title,
      imgLoaded,
      visible,
      files,
      description,
      success,
      mainResourceId,
      resourcesFromPoints,
      mainResource,
      pointName,
      getResources,
      getFile,
      handleImageChange,
      addCircle,
      send,
      selectFile,
      save,
      getMainResource,
      getResourcesFromPoints,
      navigate,
      navigateToIntermediate,
    };
  },
};
</script>

<style scoped>
.nav-section {
  margin-bottom: 15px;
}
.back-btn {
  margin-left: 7%;
}
.container-section {
  flex-basis: 40%;
}
.hr-bottom {
  margin-bottom: 15px;
}
.form-section {
  flex-basis: 35%;
}
.send-btn {
  margin-left: 20%;
  margin-top: 20px;
}
.select-section {
  width: 30%;
  margin-left: 5px;
}
.save-section {
  text-align: right;
  margin-right: 5%;
  margin-bottom: -10%;
}
.main-section {
  display: flex;
  justify-content: start;
}
.add-circle-section {
  width: 20%;
}

.menu {
  margin: 1%;
  display: flex;
  justify-content: space-between;
}
</style>